
<template>
    <div class="clinical-trial mb-5">
        <div class="container clinical-trial__container">
            <div class="clinical-trial__wrapper phd--shadow-border">
                <div class="row">
                    <div class="col-12 col-lg-4 clinical-trial__description">
                        <div v-for="(row, rowIndex) in tableData.table.sidebarContent" 
                            :key="rowIndex" 
                            class="clinical-trial__text-block">
                            
                            <div v-if="row.title" class="row-description" 
                            v-html="row.title"></div>
                            <div v-if="row.content" class="row-description" 
                            v-html="row.content"></div>
                        </div>
                    </div>

                    <!-- Begin: Clinical Trial "Table" Mobile -->
                        <div class="col-12 clinical-table__content-group d-md-none">
                            <!-- Begin: "table" -->
                            <div v-for="(row, rowIndex) in tableData.table.rows" 
                                :key="rowIndex"
                                class="clinical-table general-endpoints" 
                                :class="{'collapsed': !row.active}">
                                <div 
                                    v-on:click="row.active = !row.active" 
                                    class="clinical-table__cell clinical-table__cell--head">
                                    <span class="row-title" v-html="row.name"></span>

                                    <span v-if="row.name" class="row-description d-none d-md-block" 
                                    v-html="row.name"></span>
                                </div>
    
                                <span 
                                    v-for="(col, colIndex) in row.colData" 
                                    :key="colIndex"
                                    class="clinical-table__cell">
                                    <div v-if="col.values[colIndex]" 
                                        class="row">
                                        <div class="col-6 md-d-none general-endpoints__mobile-label">
                                            <template v-if="col.values[0]">
                                                <span class="general-endpoints__mobile-label-top" v-html="col.titles[0]"></span>
                                                <span v-if="col.names[0]" class="general-endpoints__mobile-label-bottom" v-html="col.names[0]"></span>
                                            </template>

                                            <template v-if="col.values[1]">
                                                <span class="general-endpoints__mobile-label-top" v-html="col.titles[1]"></span>
                                                <span v-if="col.names[1]" class="general-endpoints__mobile-label-bottom" v-html="col.names[1]"></span>
                                            </template>
                                        </div>
                      
                                        <div class="col-6 general-endpoints__value text-right">
                                            <div class="row">
                                                <span v-if="col.values[0]" class="col-12 general-endpoints__value" v-html="col.values[0]"></span>
                                                <span v-if="col.values[1]" class="col-12 general-endpoints__value-bottom" v-html="col.values[1]"></span>
                                            </div>
                                        </div>
                                        
                                        <div v-if="col.result" class="col-12 general-endpoints__mobile-label-results" v-html="col.result"></div>

                                    </div>
                                </span>
                            </div>
                            <!-- End:  "table" -->
                        </div>
                    <!-- End:  Clinical Trial "Table" Mobile -->

                    <div class="col-12 col-lg-8">
                        <!-- Begin: Clinical Trial "Table" -->
                        <div class="clinical-trial__table d-none d-md-block">
                            <div class="row d-none d-md-flex clinical-trial__table-colheaders">
                                <div class="col-4"><!-- purposefully empty--></div>

                                <div class="col-4">
                                    <div class="row">
                                        <div class="col-5">
                                            Vit D3
                                        </div>
                                        <div class="col-5">
                                            placebo
                                        </div>
                                        <span class="d-none d-md-block col-md-2"></span>
                                    </div>
                                </div>
                                
                                <div class="col-4">
                                    <div class="row">
                                        <div class="col-5">
                                            O3FA
                                        </div>
                                        <div class="col-5">
                                            placebo
                                        </div>
                                        <span class="d-none d-md-block col-md-2"></span>
                                    </div>
                                </div>
                            </div>

                            <div v-for="(row, rowIndex) in tableData.table.rows" 
                                :key="rowIndex" 
                                class="row clinical-trial__table-colrows ">
                                <div class="col-12 col-md-4 collapse-trigger clinical-trial__table-name" v-html="row.name"></div>
                                <div class="col-12 col-md-8">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="row clinical-trial__table-datarow">
                                                <span class="col-6">
                                                    <div class="row">
                                                        <span class="col-md-5">{{ row.colData[0].values[0] }}</span>
                                                        <span class="col-md-5">{{ row.colData[0].values[1] }}</span>
                                                        <span class="d-none d-md-block col-md-2"><!-- purposefully empty--></span>
                                                    </div>
                                                </span>
                                                <span class="col-6">
                                                    <div class="row">
                                                        <span class="col-md-5">{{ row.colData[1].values[0] }}</span>
                                                        <span class="col-md-5">{{ row.colData[1].values[1] }}</span>
                                                        <span class="d-none d-md-block col-md-2"><!-- purposefully empty--></span>
                                                    </div>
                                                </span>
                                            
                                                <span 
                                                    v-for="(col, colIndex) in row.colData"
                                                    :key="colIndex" 
                                                    class="col-12 col-md-6 clinical-trial__table-resultLabel text-right"
                                                    :class="{'clinical-trial__table-empty-trial': !col.resultsLabel[colIndex]}">
                                                        {{ col.resultsLabel }}
                                                </span>
                                            </div>
                                              
                                        </div>
                                        <div class="col-12">
                                            <div class="row clinical-trial__table-resultrow">
                                                <span 
                                                    v-for="(col, colIndex) in row.colData"
                                                    :key="colIndex" 
                                                    class="col-6 col-md-6">
                                                        {{ col.result }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                          
                            </div>
                        </div>
                        <!-- End:   Clinical Trial "Table" -->

                        <hr class="clinical-trial__results-divider mx-md-4 d-none d-md-block" />

                        <!-- Results Content - - - - - -->
                        <slot name="results"></slot>
                        <!-- // End results content - -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            trialContent: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                tableData: {}
            }
        },
        beforeMount() {
            this.tableData = this.trialContent;
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/clinical-trial-component.vue